import styled from "styled-components";
import { createShouldForwardPropBlockList } from "../../utils/helper";
import { type SliderProps } from "../slider";

type WrapperProps = Pick<SliderProps, "slidesPerView" | "spaceBetween" | "space">;

export const Wrapper = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["slidesPerView", "spaceBetween", "space"]),
})<WrapperProps>(({ slidesPerView = 1, spaceBetween = 0, space = 0, theme }) => {
    const totalSpaceBetween = (slidesPerView - 1) * spaceBetween;
    const slideWidth = `calc(((100% - 0px) - ${totalSpaceBetween}px) / ${slidesPerView})`;
    return {
        flexShrink: 0,
        transitionProperty: "transform",
        transitionDuration: "300ms",
        transitionTimingFunction: theme.transitionTimingFunction["out-cubic"],
        width: slideWidth,
        ...(space && { scrollMargin: `${space}px` }),
    };
});
